define("shared/components/shared/tax-id-form", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <form {{on "submit" @onSubmit}} ...attributes>
    <div class="o--formWrapper u--m__b__xs">
      {{! @glint-ignore: Ember changeset values are typed as unknown but Input expects a string}}
      <Input
        @type="text"
        @value={{@taxIdChangeset.businessName}}
        class={{if @taxIdChangeset.error.businessName "o--form__input--hasError"}}
        data-test-id="tax-business-name"
        id="business-name"
        placeholder={{t "checkout.tax.tax_id.name_placeholder"}}
        {{! @glint-expect-error: autofocus}}
        {{autofocus}}
      />
      {{#if @taxIdChangeset.error.businessName}}
        <span class="o--form__helpText is--error u--m__tb__xs">
          {{t "checkout.tax.tax_id.business_error"}}
        </span>
      {{/if}}
    </div>
    <div class="o--formWrapper u--m__b">
      {{! @glint-ignore: Ember changeset values are typed as unknown but Input expects a string}}
      <Input
        @type="text"
        @value={{@taxIdChangeset.taxId}}
        class={{if @taxIdChangeset.error.taxId "o--form__input--hasError"}}
        data-test-id="tax-id"
        id="tax-id"
        placeholder={{t "checkout.tax.tax_id.tax_id_placeholder"}}
      />
      {{#if @taxIdChangeset.error.taxId}}
        <span class="o--form__helpText is--error u--m__tb__xs">
          {{t "checkout.tax.tax_id.tax_id_error"}}
        </span>
      {{/if}}
    </div>
  
    <div class="o--form__checkbox">
      <label>
        <Input
          {{! @glint-ignore: Ember changeset values are typed as unknown but Input expects a boolean}}
          @checked={{@taxIdChangeset.didConfirm}}
          @type="checkbox"
          class={{concat-classes "o--form__checkbox" (if @taxIdChangeset.error.didConfirm "o--form__input--hasError")}}
          data-test-id="confirm-vat"
          id="confirm-correct"
          placeholder={{t "checkout.tax.tax_id.tax_id_placeholder"}}
        />
        <span class="u--text--light">{{html-safe (t "checkout.tax.tax_id.confirm_valid")}}</span>
      </label>
    </div>
  
    {{#unless @shouldHideSubmitButton}}
      <Shared::Ui::Button
        @isDisabled={{@isDisabled}}
        @text={{t "checkout.tax.apply_vat"}}
        class="tCH--btn--primary o--btn--block"
        data-test-id="apply-vat"
        type="submit"
      />
    {{/unless}}
  </form>
  */
  {
    "id": "0+cCYkqy",
    "block": "[[[11,\"form\"],[17,1],[4,[38,0],[\"submit\",[30,2]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--formWrapper u--m__b__xs\"],[12],[1,\"\\n\"],[1,\"    \"],[8,[39,1],[[16,0,[52,[30,3,[\"error\",\"businessName\"]],\"o--form__input--hasError\"]],[24,\"data-test-id\",\"tax-business-name\"],[24,1,\"business-name\"],[16,\"placeholder\",[28,[37,3],[\"checkout.tax.tax_id.name_placeholder\"],null]],[4,[38,4],null,null]],[[\"@type\",\"@value\"],[\"text\",[30,3,[\"businessName\"]]]],null],[1,\"\\n\"],[41,[30,3,[\"error\",\"businessName\"]],[[[1,\"      \"],[10,1],[14,0,\"o--form__helpText is--error u--m__tb__xs\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"checkout.tax.tax_id.business_error\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"o--formWrapper u--m__b\"],[12],[1,\"\\n\"],[1,\"    \"],[8,[39,1],[[16,0,[52,[30,3,[\"error\",\"taxId\"]],\"o--form__input--hasError\"]],[24,\"data-test-id\",\"tax-id\"],[24,1,\"tax-id\"],[16,\"placeholder\",[28,[37,3],[\"checkout.tax.tax_id.tax_id_placeholder\"],null]]],[[\"@type\",\"@value\"],[\"text\",[30,3,[\"taxId\"]]]],null],[1,\"\\n\"],[41,[30,3,[\"error\",\"taxId\"]],[[[1,\"      \"],[10,1],[14,0,\"o--form__helpText is--error u--m__tb__xs\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"checkout.tax.tax_id.tax_id_error\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"o--form__checkbox\"],[12],[1,\"\\n    \"],[10,\"label\"],[12],[1,\"\\n      \"],[8,[39,1],[[16,0,[28,[37,5],[\"o--form__checkbox\",[52,[30,3,[\"error\",\"didConfirm\"]],\"o--form__input--hasError\"]],null]],[24,\"data-test-id\",\"confirm-vat\"],[24,1,\"confirm-correct\"],[16,\"placeholder\",[28,[37,3],[\"checkout.tax.tax_id.tax_id_placeholder\"],null]]],[[\"@checked\",\"@type\"],[[30,3,[\"didConfirm\"]],\"checkbox\"]],null],[1,\"\\n      \"],[10,1],[14,0,\"u--text--light\"],[12],[1,[28,[35,6],[[28,[37,3],[\"checkout.tax.tax_id.confirm_valid\"],null]],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[51,[30,4]],[[[1,\"    \"],[8,[39,8],[[24,0,\"tCH--btn--primary o--btn--block\"],[24,\"data-test-id\",\"apply-vat\"],[24,4,\"submit\"]],[[\"@isDisabled\",\"@text\"],[[30,5],[28,[37,3],[\"checkout.tax.apply_vat\"],null]]],null],[1,\"\\n\"]],[]],null],[13]],[\"&attrs\",\"@onSubmit\",\"@taxIdChangeset\",\"@shouldHideSubmitButton\",\"@isDisabled\"],false,[\"on\",\"input\",\"if\",\"t\",\"autofocus\",\"concat-classes\",\"html-safe\",\"unless\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/tax-id-form.hbs",
    "isStrictMode": false
  });
  const TaxIdForm = (0, _templateOnly.default)();
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TaxIdForm);
});